import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shared-member-terms-conditions',
  templateUrl: './shared-member-terms-conditions.component.html',
  styleUrls: ['./shared-member-terms-conditions.component.scss']
})
export class SharedMemberTermsConditionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
